export const getSessionStorageItem = (key) => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.sessionStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

export const setSessionStorageItem = (key, value) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.setItem(key, value);
  } catch (error) {
    // Ignore storage failures so UX still works in private mode / restricted environments.
  }
};

export const removeSessionStorageItem = (key) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.removeItem(key);
  } catch (error) {
    // Ignore storage failures so UX still works in private mode / restricted environments.
  }
};
